import EF from 'ef/ef';
import BlockView from 'views/block/base-block-view';
import EnrollmentDataService from 'services/data-handler-services/enrollment-data-service';
import Chaplin from 'chaplin';

const MultimediaBlockView = BlockView.extend({
  initialize: function (opts) {
    if (EF.enrollment && EF.enrollment.attributes) {
      if (EF.enrollment.has('autoPlay') && this.type !== 'video') {
        this.model.set('auto_play', EF.enrollment.get('autoPlay'));
      }
      const settings = EnrollmentDataService.getData('settings');
      if (settings && settings[this.type]) {
        this.model.set('settings', settings[this.type]);
        if (settings[this.type][`${this.type}-mute`]) {
          this.model.set('muted', settings[this.type][`${this.type}-mute`]);
        }
      }
    }
    BlockView.prototype.initialize.call(this, opts);
  },
  otherMediaPlayingHandler(view, type, callback = () => {}) {
    const subscribe = Chaplin.mediator.subscribe || view.subscribeEvent;
    subscribe(
      'media:status:changed',
      (mediaState, mediaId, mediaType) => {
        if (mediaState === 'playing' && type !== mediaType) {
          callback();
        }
      },
      view
    );
  },
  dispose: function () {
    BlockView.prototype.dispose.call(this, arguments);
  },
});

export default MultimediaBlockView;
